module.exports = __webpack_public_path__ + "static/media/02_web_marketing-linvitation.60d09df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_marketing-linvitation.jpg
// module id = 285
// module chunks = 0